import { ZONE, type Surface } from "./constants";

export type CanonicalForm = "host" | "path";

export type UrlParts = {
  slug: string;
  /** Registry metadata (curation / SEO hints). Not part of the public URL. */
  surface?: Surface;
  canonical?: CanonicalForm;
};

/** Host door: `{slug}.over9000.cc` */
export function hostUrl(slug: string, zone = ZONE): string {
  return `https://${slug}.${zone}`;
}

/** Path door: `over9000.cc/{slug}` */
export function pathUrl(slug: string, zone = ZONE): string {
  return `https://${zone}/${slug}`;
}

/** Canonical public URL. Defaults to the host door (Worker SEO link). */
export function canonicalUrl(app: UrlParts, zone = ZONE): string {
  const form = app.canonical ?? "host";
  return form === "path" ? pathUrl(app.slug, zone) : hostUrl(app.slug, zone);
}

/**
 * Human URL for the mosaic, registry list, and detail modal.
 * Always the fully qualified path door, even when `canonical` is `"host"`.
 * `surface` on `app` is ignored — it is metadata, not part of the URL.
 */
export function displayUrl(app: UrlParts, zone = ZONE): string {
  return pathUrl(app.slug, zone);
}

export function hostLabel(slug: string, zone = ZONE): string {
  return `${slug}.${zone}`;
}

export function pathLabel(slug: string): string {
  return `/${slug}`;
}
